import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faBell,
    faCheckDouble,
    faGaugeHigh,
    faUser,
    faUsers,
    faRightFromBracket,
    faRightToBracket,
    faGear,
    faHouse,
    faShieldHalved,
    faBars,
    faXmark,
    faChartLine,
    faChevronDown,
    faTriangleExclamation,
    faMagnifyingGlass,
    faNewspaper,
    faLayerGroup,
    faTableCellsLarge,
    faUpRightFromSquare,
    faPlus,
    faPen,
    faTrash,
    faLocationCrosshairs,
    faWind,
    faDroplet,
    faCloud,
    faTemperatureHalf,
    faCompass,
    faEnvelope,
    faArrowRight,
    faCartShopping,
    faMountainSun,
    faCloudBolt,
    faFlaskVial,
    faCode,
    faMicrochip,
    faRobot,
    faCubes,
    faShip,
    faCircleNodes,
    faLeaf,
    faScrewdriverWrench,
    faInfinity,
    faWater,
    faCube,
    faDesktop,
    faMobileScreen,
    faLock,
    faBan,
    faArrowLeft,
    faCheck,
    faCloudArrowUp,
    faPaperclip,
    faExclamation,
    faAnglesLeft,
    faAnglesRight,
    faFilter,
    faClockRotateLeft,
    faCalendarDays,
    faChevronLeft,
    faChevronRight,
    faFlag,
    faClock,
    faRocket,
    faUserShield,
} from '@fortawesome/free-solid-svg-icons'
import { faGithub, faGoogle, faApple } from '@fortawesome/free-brands-svg-icons'

library.add(
    faBell,
    faCheckDouble,
    faGaugeHigh,
    faUser,
    faUsers,
    faRightFromBracket,
    faRightToBracket,
    faGear,
    faHouse,
    faShieldHalved,
    faBars,
    faXmark,
    faChartLine,
    faChevronDown,
    faTriangleExclamation,
    faMagnifyingGlass,
    faNewspaper,
    faLayerGroup,
    faTableCellsLarge,
    faUpRightFromSquare,
    faPlus,
    faPen,
    faTrash,
    faLocationCrosshairs,
    faWind,
    faDroplet,
    faCloud,
    faTemperatureHalf,
    faCompass,
    faEnvelope,
    faArrowRight,
    faCartShopping,
    faMountainSun,
    faCloudBolt,
    faFlaskVial,
    faCode,
    faMicrochip,
    faRobot,
    faCubes,
    faShip,
    faCircleNodes,
    faLeaf,
    faScrewdriverWrench,
    faInfinity,
    faWater,
    faCube,
    faDesktop,
    faMobileScreen,
    faLock,
    faBan,
    faArrowLeft,
    faCheck,
    faCloudArrowUp,
    faPaperclip,
    faExclamation,
    faAnglesLeft,
    faAnglesRight,
    faFilter,
    faClockRotateLeft,
    faCalendarDays,
    faChevronLeft,
    faChevronRight,
    faFlag,
    faClock,
    faRocket,
    faUserShield,
    faGithub,
    faGoogle,
    faApple,
)
